import main from "../../images/stages/main.png";
import district from "../../images/stages/district.png";
// import soundr from '../../images/stages/soundR.png';
import truband from "../../images/stages/truband.png";
import rare from "../../images/stages/rare.png";
import soundr from "../../images/stages/soundr.png";
import nuggs from "../../images/stages/nuggs.png";
import azul from "../../images/stages/azul.jpg";
import underground from "../../images/stages/underground.jpg";
import portaloo from "../../images/stages/Hour-Glass.png";
import moda from "../../images/stages/moda.jpg";
import jazz from "../../images/stages/jazz.png";
import techno from "../../images/stages/techno.png";
import rage from "../../images/stages/rage.jpg";
import ravers from "../../images/stages/rr.png";

export default [
  {
    name: "Random Ravers",
    href: "https://play.decentraland.org/?position=-54%2C60&realm=marvel&island=Ic9b0",
    src: ravers,
    coord: "-54,60",
  },

  {
    name: "Nuggs.net",
    href: "https://play.decentraland.org/?position=-71%2C91&realm=marvel&island=Ic88c",
    src: nuggs,
    coord: "-71,91",
  },
  {
    name: "Casa Azul Stage",
    href: "https://play.decentraland.org/?position=-71%2C88&realm=marvel&island=Ic88c",
    src: azul,
    coord: "-71,88",
  },
  {
    name: "London Underground",
    href: "https://play.decentraland.org/?position=-71%2C85&realm=marvel&island=Ic88c",
    src: underground,
    coord: "-71,85",
  },
  {
    name: "Hour Glass",
    href: "https://play.decentraland.org/?position=-71%2C79&realm=marvel&island=Ic88c",
    src: portaloo,
    coord: "-71,79",
  },
  {
    name: "Techno Stage",
    href: "https://play.decentraland.org/?position=-61%2C79&realm=marvel&island=Ic5t9",
    src: techno,
    coord: "-61,79",
  },
  {
    name: "Rage Club",
    href: "https://play.decentraland.org/?position=-71%2C83&realm=marvel&island=Ic88c",
    src: rage,
    coord: "-71,83",
  },
  {
    name: "Moda DAO",
    href: "https://play.decentraland.org/?position=-58%2C82&realm=marvel&island=Ic5t9",
    src: moda,
    coord: "-58,82",
  },
  {
    name: "Jazz Club",
    href: "https://play.decentraland.org/?position=-71%2C77&realm=marvel&island=Ic88c",
    src: jazz,
    coord: "-71,77",
  },
  {
    name: "Festival District",
    href: "https://play.decentraland.org/?position=-63%2C83&realm=marvel&island=Ic5t9",
    src: district,
    coord: "-63,83",
  },

  {
    name: "SoundR",
    href: "https://play.decentraland.org/?position=-70%2C67&realm=marvel&island=Ic5t9",
    src: soundr,
    coord: "-70,67",
  },
  {
    name: "Tru Band Room",
    href: "https://play.decentraland.org/?position=-71%2C71&realm=marvel&island=Ic9b0",
    src: truband,
    coord: "-71,71",
  },

  {
    name: "Rare Store",
    href: "https://play.decentraland.org/?position=-58%2C92&realm=marvel&island=Ic88c",
    src: rare,
    coord: "-58,92",
  },
];
